;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { useCallback, useRef } from "react"
import { useMutation } from "@apollo/client/react"
import stripeCustomerSetupIntent from "../../graphql/mutations/stripe/stripeCustomerSetupIntent"
import registerStripeCustomer from "../../graphql/mutations/stripe/registerStripeCustomer"
import updateErrorMessage from "../../graphql/mutations/snackbarMessage/updateErrorMessage"
import get from "lodash/get"

const STRIPE_CUSTOMER_ACCOUNT_ALREADY_EXISTS_ERROR = "Customer Already Exists"

export type RegisterStripeCustomerData = {
  registerStripeCustomer?: { success?: boolean }
}

export type SetupIntentData = {
  stripeCustomerSetupIntent?: { setupIntentClientSecret?: string }
}

export default function useStripeCustomer(): {
  registerStripeCustomerAndSetupIntent: () => Promise<string | null>
} {
  const [registerStripeCustomerFunc] = useMutation<RegisterStripeCustomerData>(
    registerStripeCustomer,
  )
  const [stripeCustomerSetupIntentFunc] = useMutation<SetupIntentData>(
    stripeCustomerSetupIntent,
  )
  const setupIntentInProgressRef = useRef<boolean>(false)

  const handleStripeCustomerSetupIntent = useCallback(async (): Promise<
    string | null
  > => {
    if (setupIntentInProgressRef.current) {
      return null
    }

    try {
      setupIntentInProgressRef.current = true
      const { data: getStripeAccountLinkData } =
        await stripeCustomerSetupIntentFunc()

      const stripeCustomerSecretKey = get(
        getStripeAccountLinkData,
        "stripeCustomerSetupIntent.setupIntentClientSecret",
        null,
      ) as string | null

      return stripeCustomerSecretKey
    } catch (error) {
      updateErrorMessage(get(error, "message", "Error occured. Please try again."))
      return null
    } finally {
      setupIntentInProgressRef.current = false
    }
  }, [stripeCustomerSetupIntentFunc])

  const registerStripeCustomerAndSetupIntent = useCallback(async () => {
    try {
      const { data: registerStripeCustomerData } = await registerStripeCustomerFunc()

      const isRegisterStripeCustomerSuccess = get(
        registerStripeCustomerData,
        "registerStripeCustomer.success",
        false,
      )
      if (isRegisterStripeCustomerSuccess) {
        return handleStripeCustomerSetupIntent()
      }

      throw new Error("Failed to register Stripe customer")
    } catch (error) {
      const errorMessage = get(error, "message", "Error occured. Please try again.")
      if (errorMessage === STRIPE_CUSTOMER_ACCOUNT_ALREADY_EXISTS_ERROR) {
        return handleStripeCustomerSetupIntent()
      }

      updateErrorMessage({
        message: errorMessage,
        trackToSentry: true,
        error,
      })

      throw error
    }
  }, [registerStripeCustomerFunc, handleStripeCustomerSetupIntent])

  return { registerStripeCustomerAndSetupIntent }
}
